import { useEffect, useRef } from 'react';

import { hash, nothing } from '../utils';
import { useFilter } from './useFilter';
import { useHasAccess } from './useHasAccess';
import { useLocalStorage } from './useLocalStorage';
import { useFleet } from './useFleet';

export const useRouteEventTypes = (): [selectedFilters: string[], setSelectedFilters: (value: string[]) => void] => {
  const filter = useFilter();
  const [lsSelectedFilter, setLsSelectedFilter] = useLocalStorage('routeEventTypes', filter.selectedFilters ?? []);
  const fleet = useFleet();
  const isInternalUser = useHasAccess();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the effect on initial mount
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setLsSelectedFilter(filter.selectedFilters?.filter(Boolean) ?? []);
  }, [hash(filter.selectedFilters), fleet.id]);

  // only internal users can mess with route overlays
  if (!isInternalUser) {
    return [filter.selectedFilters?.filter(Boolean) ?? [], nothing];
  }

  return [lsSelectedFilter, setLsSelectedFilter];
};
